export default {
    API_ENDPOINT: 'https://powerful-scrubland-63666.herokuapp.com/api'
}

//http://localhost:8000/api
//https://powerful-scrubland-63666.herokuapp.com/api